module.exports = __webpack_public_path__ + "media/images/icons/outlined/rest-15bd338a6367373f465c3dbd3d37b32e.svg";